import { SurveyType } from 'components/molecules/SurveyItem/SurveyItem';
import useFormatCurrency from 'hooks/useFormatCurrency';
import React from 'react';
import { formatCurrency } from '../../../utils/locale';
import { SurveyItem_survey$data } from '../../molecules/SurveyItem/__generated__/SurveyItem_survey.graphql';
import { SCREENER_SURVEY } from '../pages';

interface SurveySettings {
  id: string;
  title?: string;
  reward: number | null;
  duration: number;
  lockedInfo?: SurveyType['lockedInfo'];
}

export function createFakeSurvey(overwrites: Partial<SurveyType> = {}): SurveyType {
  return {
    id: 'default-1',
    duration: 3,
    reward: null,
    tags: ['locked'],
    title: 'Sign up to unlock great surveys like this',
    supportId: 'mobile-app-static-signup',
    studyId: 'mobile-app-static-signup',
    baseReward: null,
    lockedInfo: null,
    status: 'AVAILABLE',
    startedAt: null,
    statusDescription: 'AVAILABLE',
    imageUrl: 'https://cdn.assets.qmee.com/images/57-385cbc592f275441abaada185b52562a.jpg',
    iconUrl: 'https://www.qmee.com/favicon.svg',
    url: null,
    fraudType: null,
    durationDetails: {
      min: overwrites.duration || 2,
      median: overwrites.duration || 2,
      max: overwrites.duration || 2,
      providerDuration: overwrites.duration || 2,
    },
    adminData: null,
    ...overwrites,
  };
}

export function useStaticSurveys(): SurveyType[] {
  const formatCurrency = useFormatCurrency();
  return React.useMemo(() => {
    function createMoneyAmount(
      cents: number,
    ): { readonly formatted: string; readonly cents: number; readonly currency: string } | null {
      const formatted = formatCurrency(cents);
      return {
        formatted,
        cents,
        currency: 'USD',
      };
    }
    return [
      createFakeSurvey({
        id: 'prescreener',
        reward: null,
        duration: 3,
        title: 'Sign up to unlock great surveys like these!',
        tags: ['screener', 'hot'],
        url: SCREENER_SURVEY.path,
        imageUrl: 'https://cdn.assets.qmee.com/images/57-385cbc592f275441abaada185b52562a.jpg',
      }),
      createFakeSurvey({
        id: 'static-1',
        reward: createMoneyAmount(83),
        duration: 8,
        title: 'Travel',
        tags: ['hot'],
        imageUrl: 'https://cdn.assets.qmee.com/images/274-e0ca74e86d2da37ac4db8a22661f9eb9.jpg',
      }),
      createFakeSurvey({
        id: 'static-2',
        reward: createMoneyAmount(114),
        duration: 8,
        title: 'Fashion',
        tags: ['hot', 'new'],
        imageUrl: 'https://cdn.assets.qmee.com/images/147-b2f34e7996dd3ceda5247599aaea4751.jpg',
      }),
      createFakeSurvey({
        id: 'static-3',
        reward: createMoneyAmount(54),
        duration: 9,
        title: 'Money',
        tags: ['new'],
        imageUrl: 'https://cdn.assets.qmee.com/images/155-6d72ae33ecd23924eeb2ff241e3da961.jpg',
      }),
      createFakeSurvey({
        id: 'static-4',
        reward: createMoneyAmount(92),
        duration: 5,
        title: 'Food',
        tags: ['webcam'],
        imageUrl: 'https://cdn.assets.qmee.com/images/152-07ecd88e425a4c68d385a1be4684a6e2.jpg',
      }),
      createFakeSurvey({
        id: 'static-5',
        reward: createMoneyAmount(32),
        duration: 12,
        title: 'Health',
        imageUrl: 'https://cdn.assets.qmee.com/images/181-cb75b2c49b800304d96273288005e4ac.jpg',
      }),
    ];
  }, [formatCurrency]);
}
